// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2b438ae7","701":"cd9e167f","742":"dd969990","817":"e57ef327","932":"02d7db9b"}[chunkId] + ".chunk.js";
};